<button mat-fab extended (click)="showPromoDialog()" color="primary" [class.shake]="has_promos"
    [extended]="(layout.is_desktop | async)||!compact">
    <mat-icon>local_play</mat-icon>
    <span *ngIf="(layout.is_desktop | async)||!compact">{{has_promos ? 'Промокоди' : 'Розпродажі'}}</span>
</button>